'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { HeroBanner, type HeroBannerPageTitle } from '@/components/frontend/common/hero-banner';
import { ModulesGrid } from '@/components/frontend/modules/modules-grid';

type ModuleItem = { id: string; title: string; description: string; image?: string | null };

export function ModulesPageContent({ initialModules, initialPageTitle }: { initialModules?: ModuleItem[]; initialPageTitle?: HeroBannerPageTitle | null } = {}) {
    const t = useTranslations('modules');

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
            <HeroBanner
                page="modules"
                title={t('title')}
                description={t('description')}
                pill={t('pillLabel')}
                initialPageTitle={initialPageTitle}
            />

            <SectionWrapper variant="default" padding="lg" className="relative overflow-hidden">
                <div className="pointer-events-none absolute inset-0 opacity-40">
                    <div className="absolute left-10 top-10 h-80 w-80 rounded-full bg-primary-500/10 blur-3xl" />
                    <div className="absolute right-10 bottom-10 h-80 w-80 rounded-full bg-blue-500/10 blur-3xl" />
                </div>

                <div className="relative z-10 max-w-7xl mx-auto">
                    <ModulesGrid initialModules={initialModules} />
                </div>
            </SectionWrapper>
        </div>
    );
}

